<template>
	<div class="container-fluid">
		<div class="card">
      <div class="card-header">
        <h2 class="card-title">Mis créditos activos</h2>
      </div>
      <div class="card-body">
        <CreditTabs />
      </div>
    </div>
	</div>
</template>

<script>
import CreditTabs from '../components/CreditTabs'
import api from '@/api/clientes'

export default {
  components: {
    CreditTabs
	}
}
</script>

<style lang="scss">
  .avatar-video {
    margin-left: 15%;

    video {
      width: 80%;
    }
  }
</style>